
//TEST DATA
// export default {
//     HOST: 'https://nexyo.ro',
//     API_HOST: 'http://localhost:8000/api/v2',
//     NODE_HOST: 'https://nexyo.ro:8443', //onserver
//     CLIENT_HOST: 'localhost:8080',
//     // STRIPE_KEY: 'pk_test_51IfLmOBgnLrPR2P3e7m00qheuANmeMX5O5oKyJdbIQCvOD6Ue3TVadC8UVVGLIGUHBQgWL0lDqygnRuy11BW8AJG00TpgXkIQJ',
//     STRIPE_KEY: 'pk_live_51IfLmOBgnLrPR2P3XZKELn4KbdVrzzTWpJLZwZDZAkYaj3qS0C1ifr0MM89I2BJKxaQOfuPDdjd7ZJPNeMJADMC0009zNiFQqW',
//     FILESTACK_KEY: 'A7sjolz9HSR6sv5JFH9gAz',
//     FILESTACK_CDN: 'https://cdn.filestackcontent.com/',
//     GOOGLE_GTM_CODE: 'NO_TAG_MANAGER',
//     GOOGLE_AW_GTAG_CODE: 'NO_AW_GTAG',
//     GOOGLE_UA_GTAG_CODE: 'NO_UA_GTAG',
//     FACEBOOK_PIXEL_CODE: 'NO_FB_PIXEL',
//     HOTJAR_ID: 'NO_HOTJAR_ID',
//     HOTJAR_SV: '6',
//     FACEBOOK_AUTH_ID: '366966798361128',
//     GOOGLE_AUTH_ID: '339683494756-bopqrp3auu50ksf1ogsnegivcf1hh9gk.apps.googleusercontent.com'
// }

// LIVE DATA
export default {
    HOST: 'https://nexyo.ro',
    API_HOST: 'https://nexyo.ro/api/v2',
    NODE_HOST: 'https://nexyo.ro:8443', //onserver
    CLIENT_HOST: 'https://app.nexyo.ro',
    //STRIPE_KEY: 'pk_test_51IfLmOBgnLrPR2P3e7m00qheuANmeMX5O5oKyJdbIQCvOD6Ue3TVadC8UVVGLIGUHBQgWL0lDqygnRuy11BW8AJG00TpgXkIQJ',
    STRIPE_KEY: 'pk_live_51IfLmOBgnLrPR2P3XZKELn4KbdVrzzTWpJLZwZDZAkYaj3qS0C1ifr0MM89I2BJKxaQOfuPDdjd7ZJPNeMJADMC0009zNiFQqW',
    FILESTACK_KEY: 'A7sjolz9HSR6sv5JFH9gAz',
    FILESTACK_CDN: 'https://cdn.filestackcontent.com/',
    GOOGLE_GTM_CODE: 'NO_TAG_MANAGER',
    GOOGLE_AW_GTAG_CODE: 'AW-701412762',
    GOOGLE_UA_GTAG_CODE: 'UA-148896132-12',
    FACEBOOK_PIXEL_CODE: '1021935735014130',
    HOTJAR_ID: '2493199',
    HOTJAR_SV: '6',
    FACEBOOK_AUTH_ID: '366966798361128',
    GOOGLE_AUTH_ID: '339683494756-bopqrp3auu50ksf1ogsnegivcf1hh9gk.apps.googleusercontent.com'
}
